import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Portal from 'portal/Portal';
import BaseForm from 'containers/Base/BaseForm';
import { initialState } from './serviceOptions';
import {
  getSecurityCompanyAllowableServices,
  updateSecurityCompany,
} from 'reducers/securityCompany';
import staticText from 'static/text_display.json';
import { HelpLinks } from 'utils/constants/helpLinks';
import { USER_FIELDS } from 'utils/formFields/user';
import { getServiceByCategory } from 'utils/helper/product';

const EditServices = ({
  securityCompany,
  close,
  updateSecurityCompany,
  allowableServices,
}) => {
  const onEdit = values => {
    const services = [];
    Object.values(values).forEach(item => services.push(...item));

    updateSecurityCompany(securityCompany.id, {
      name: securityCompany.name,
      contact: securityCompany.contact,
      regionId: securityCompany.regionId,
      regionName: securityCompany.regionName,
      operationPhone: securityCompany.operationPhone,
      bookingPhone: securityCompany.bookingPhone,
      services,
    });
    close();
  };
  return (
    <Portal id={'portal'} type={'modal'}>
      <BaseForm
        formTitle={staticText.account_view.edit_services}
        size={'s'}
        initialValues={initialState(
          securityCompany.services,
          allowableServices,
        )}
        closeForm={close}
        saveHoverText={staticText.account_view.update_services}
        generalSection={USER_FIELDS.services({
          services: getServiceByCategory({ services: allowableServices }),
        })}
        imageRequired={false}
        onSubmit={onEdit}
        formInfo={{
          link: HelpLinks.serviceLink,
          value: HelpLinks.serviceText,
        }}
      />
    </Portal>
  );
};
EditServices.propTypes = {
  close: PropTypes.func,
  securityCompany: PropTypes.object,
  updateSecurityCompany: PropTypes.func,
  allowableServices: PropTypes.array,
};

const mapStateToProps = state => ({
  allowableServices: getSecurityCompanyAllowableServices(state),
});

const mapDispatchToProps = dispatch => ({
  updateSecurityCompany: (id, securityCompany) =>
    dispatch(updateSecurityCompany(id, securityCompany)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EditServices);
